<template>
    <div id="fale-conosco-v2">
        <ContactUsBanner :isMobile="isMobile" />
        <div id="fale-conosco-content">
            <ContactUsIntro />
            <div id="contacts">
                <EmailForm />
                <div v-if="!isMobile" id="vertical-divider" />
                <OtherContacts />
            </div>
        </div>
    </div>
</template>

<script>
    import ContactUsBanner from './ContactUsBanner.vue';
    import ContactUsIntro from './ContactUsIntro.vue';
    import EmailForm from './EmailForm.vue';
    import OtherContacts from './OtherContacts.vue';
    import { resizeOrientationAware } from '../../../common/common';

    export default {
        name: 'ContactUs',
        components: {
            ContactUsBanner,
            ContactUsIntro,
            EmailForm,
            OtherContacts,
        },
        el: '#contact-us-vue',

        data() {
            return {
                isMobile: false,
                resizeAwareRemoveCb: null,
            };
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => {
                this.isMobile = window.innerWidth < 992;
            }, true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },
    };
</script>
